import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getNotesByIdWorkoutSelector from 'modules/workout/redux/selectors/get-notes-by-id/index.js'
import Textarea from 'components/Textarea/index.js'
import WorkoutNotesText from 'pages/Workout/components/Workout/components/NotesText/index.js'
import Row from 'components/Row.js'
import Icon from 'components/Icon/index.js'
import { EditIcon } from 'components/Icon/icons/edit/index.js'
import Button from 'components/Button/index.js'
import {
  saveWorkoutAction,
  updateNotesWorkoutAction
} from '@gymaholic/packages'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import CheckMarkIcon from 'components/Icon/icons/check-mark/index.js'

const ICON_SIZE_IN_PX = '25px'

export default function WorkoutEditNotes ({ id }) {
  const notes = useSelector(getNotesByIdWorkoutSelector(id))
  const [isEditing, setIsEditing] = React.useState(false)
  const dispatch = useDispatch()

  const handleChange = (event) => {
    dispatch(updateNotesWorkoutAction(event.target.value))
  }

  let element
  if (isEditing) {
    element = (
      <Textarea
        value={notes}
        onChange={handleChange}
        containerStyle={{ width: '100%' }}
      />
    )
  } else {
    element = <WorkoutNotesText id={id} />
  }

  const handleClick = () => {
    if (isEditing) {
      setIsEditing(false)
      dispatch(saveWorkoutAction(id))
      return
    }
    setIsEditing(true)
  }

  return (
    <Row>
      {element}
      <Row
        ml
        ac
      >
        <Button
          onClick={handleClick}
          style={{
            height: 'auto'
          }}
          hoverableProps={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Icon
            icon={isEditing ? CheckMarkIcon : EditIcon}
            size={ICON_SIZE_IN_PX}
          />
        </Button>
      </Row>
    </Row>
  )
}
